import { Image } from "primereact/image";

import {
  labelNoResults,
  labelProjectsEmptyFirstRow,
  labelProjectsEmptySecondRow,
} from "_constants";
import notFoundProject from "../../../../../assets/images/not_found_project.svg";
import { useState } from "react";

export const EmptyCardList = ({
  filters,
}: {
  filters: {
    pageIndex: number;
    pageSize: number;
    globalSearch: string;
    type?: string;
    sorting?: string;
  };
}) => {
  const [showLabel, setShowLabel] = useState(false);

  return (
    <div className="width-100 height-100 flex-container column align-center justify-center">
      <Image src={notFoundProject} onLoad={() => setShowLabel(true)} />
      {showLabel && (
        <>
          {filters.pageIndex === 1 &&
          !filters.globalSearch?.length &&
          !filters.type &&
          !filters.sorting ? (
            <>
              <p className="empty-cards">{labelProjectsEmptyFirstRow}</p>
              <p className="empty-cards">{labelProjectsEmptySecondRow}</p>
            </>
          ) : (
            <>
              <p className="empty-cards">{labelNoResults}</p>
            </>
          )}
        </>
      )}
    </div>
  );
};
